export enum SurveyProviderType {
  Klantenvertellen = 'klantenvertellen'
}
